// extracted by mini-css-extract-plugin
export default {"icon":"style_icon__N81Az","popover":"style_popover__7D2wY"};